import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "my-2"
}
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_ContactItem = _resolveComponent("ContactItem")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list = _resolveComponent("v-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return ($data.isLoading)
    ? (_openBlock(), _createBlock(_component_BaseSpinner, {
        key: 0,
        class: "my-16"
      }))
    : (_openBlock(), _createBlock(_component_v_list, {
        key: 1,
        class: "py-0"
      }, {
        default: _withCtx(() => [
          (!$options.filteredContacts.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_list_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-center" }, {
                      default: _withCtx(() => [
                        ($options.searchQuery && $options.searchQuery.trim())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('contacts.emptyList.notFound')), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('contacts.emptyList.noContacts.title')), 1),
                              _withDirectives((_openBlock(), _createElementBlock("button", {
                                class: "info-btn",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.createContact && $options.createContact(...args)))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('contacts.emptyList.noContacts.createBtn')), 1)
                              ])), [
                                [_directive_ripple]
                              ]),
                              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('contacts.emptyList.noContacts.btnsDevider')), 1),
                              _withDirectives((_openBlock(), _createElementBlock("button", {
                                class: "info-btn",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.addDefaultContacts && $options.addDefaultContacts(...args)))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('contacts.emptyList.noContacts.autoaddBtn')), 1)
                              ])), [
                                [_directive_ripple]
                              ])
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('contacts.list.counterTitle') + $options.filteredContacts.length), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider)
              ])),
          _createVNode(_component_v_expansion_panels, {
            class: "d-block",
            modelValue: $data.expansedContact,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.expansedContact) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredContacts, (contact, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: contact.id
                }, [
                  _createElementVNode("div", null, [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_list_subheader, { class: "bg-teal-lighten-3" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.getFirstLater(contact.name)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          ($options.getFirstLater(contact.name) !== $options.getFirstLater($options.filteredContacts[index - 1].name))
                            ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                key: 0,
                                class: "bg-teal-lighten-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($options.getFirstLater(contact.name)), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                        ]))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_ContactItem, {
                      id: contact.id,
                      name: contact.name,
                      phone: contact.phone,
                      email: contact.email,
                      birthday: contact.birthday,
                      isSelected: contact.id === $data.expansedContact,
                      onEditContact: $options.editContact,
                      onDeleteContact: $options.deleteContact
                    }, null, 8, ["id", "name", "phone", "email", "birthday", "isSelected", "onEditContact", "onDeleteContact"])
                  ])
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }))
}